import axios from "axios";

export default {
    getPage (slug) {
        return axios.get(`${process.env.VUE_APP_API_PATH}${slug}`)
    }
}
